﻿import { setRequired, setVisibility } from "../helpers";
import { initLoadingStateButtons } from "../helpers";

let hasValidatedOnce = false;
const dom = {};
export function initLegacyDeclaration() {
    if (document.getElementById("declarationForm")) {
        cacheDom();
        initLoadingStateButtons();
        setInitialRequired();
        toggleAccountInput();

        dom.form.addEventListener('submit', () => { hasValidatedOnce = true; });

        dom.beneficiaryRadios.forEach(radio => {
            radio.addEventListener('change', toggleAccountInput);
        });

        [dom.constructionAmount, dom.sustainabilityAmount].forEach(elem => {
            if (!elem) {
                return;
            }
            elem.addEventListener('input', updateTotalAmount);
        });

        dom.cancel.addEventListener('click', showCancelDialog);

        dom.continue.addEventListener('click', () => {
            window.dialog.close();
        });
    }
}

function cacheDom() {
    dom.form = document.getElementById('declarationForm');

    dom.accountNumber = document.getElementById('accountNumber');
    dom.invoiceNumber = document.getElementById('invoiceNumber');
    dom.installmentNumber = document.getElementById('installmentNumber');

    dom.ownAccountNotification = document.querySelector('[data-beneficiary="own"]');
    dom.contractorAccountNotification = document.querySelector('[data-beneficiary="contractor"]');

    dom.constructionAmount = document.getElementById('ConstructionAmount');
    dom.sustainabilityAmount = document.getElementById('SustainabilityAmount');
    dom.totalAmount = document.getElementById('TotalAmount');
    dom.totalAmountShown = document.getElementById('TotalAmountShown');

    dom.constructionLabel = document.querySelector('div[data-form-field]:has(#ConstructionAmount)');
    dom.constructionTypeLabel = document.querySelector('div[data-form-field]:has(#ConstructionDeclarationType)');
    dom.sustainabilityLabel = document.querySelector('div[data-form-field]:has(#SustainabilityAmount)');
    dom.sustainabilityTypeLabel = document.querySelector('div[data-form-field]:has(#SustainabilityDeclarationType)');

    dom.beneficiaryRadios = document.querySelectorAll('input[name="BeneficiaryChoice.Value"]');
    dom.cancel = document.getElementById('cancelBtn');
    dom.continue = document.getElementById('continueBtn')
}

function setInitialRequired() {
    ["InvoiceNumber", "InstallmentNumber",
        ...(dom.constructionTypeLabel && dom.sustainabilityTypeLabel
            ? ["ConstructionDeclarationType", "SustainabilityDeclarationType"]
            : [])
    ].forEach(formFieldName => {
        const elem = document.querySelector(`.form-field[data-form-field-name="${formFieldName}"]`);
        setRequired(elem, false)
    });
}

function toggleAccountInput() {
    const value = [...dom.beneficiaryRadios].find(r => r.checked)?.value;
    const isContractor = value === "Contractor";
    const widthClass = isContractor ? "span-2" : "span-3";

    setVisibility(dom.accountNumber, isContractor);
    setVisibility(dom.ownAccountNotification, !isContractor);
    setVisibility(dom.contractorAccountNotification, isContractor);

    [dom.invoiceNumber, dom.installmentNumber].forEach(elem => {
        setRequired(elem, isContractor);
        elem?.classList.remove("span-2", "span-3");
        elem?.classList.add(widthClass);
    });

    revalidate();
}

function updateTotalAmount() {
    let constructionAmount = 0;
    let sustainabilityAmount = 0;

    if (dom.constructionAmount) {
        constructionAmount = normalizeDecimal(dom.constructionAmount.value);
        clearIfZero(dom.constructionAmount, constructionAmount);
    }

    if (dom.sustainabilityAmount) {
        sustainabilityAmount = dom.sustainabilityAmount ? normalizeDecimal(dom.sustainabilityAmount.value) : 0;
        clearIfZero(dom.sustainabilityAmount, sustainabilityAmount);
    }

    const totalAmount = constructionAmount + sustainabilityAmount;
    dom.totalAmount.value = totalAmount;
    dom.totalAmountShown.textContent = formatEuro(totalAmount);

    toggleRequiredStars(constructionAmount, sustainabilityAmount);

    revalidate();
}

function revalidate() {
    if (hasValidatedOnce) $(dom.form).valid();
}

function normalizeDecimal(amount) {
    const normalized = amount.replace(/\./g, '').replace(',', '.');
    const value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
}

function formatEuro(amount) {
    // Convert 1003.25 → "€ 1.003,25"
    return amount
        .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
        .replace('EUR', '€');
}

function clearIfZero(input, value) {
    if (value !== 0) return;

    input.value = '';
}

function toggleRequiredStars(constructionAmount, sustainabilityAmount) {
    if (!(dom.constructionLabel && dom.sustainabilityLabel)) return;

    const bothZero = constructionAmount === 0 && sustainabilityAmount === 0;

    dom.constructionLabel.classList.toggle('is-required', constructionAmount > 0 || bothZero);
    dom.sustainabilityLabel.classList.toggle('is-required', sustainabilityAmount > 0 || bothZero);

    dom.constructionTypeLabel.classList.toggle('is-required', constructionAmount > 0);
    dom.sustainabilityTypeLabel.classList.toggle('is-required', sustainabilityAmount > 0);
}

function showCancelDialog(event) {
    event.preventDefault();
    window.dialog.open({ elemId: 'cancel-dialog', size: "small" });
}